export type PurchaseQuote = {
  id: string;
  supplier: string;
  date: string;
  reference: string;
  unitTtcMicros: number;
  invoice?: {
    number: string;
    sku: string;
    quantity: number;
    unitsPerPack: number;
    lineHtMinor: number;
    vatBps: number;
  };
};
export type CatalogProduct = {
  id: string;
  name: string;
  unit: string;
  active: boolean;
  purchasePriceMinor: number;
  quotes: PurchaseQuote[];
};
export function parseTtcMicros(text: string): number {
  const value = text.trim().replace(',', '.');
  if (!/^\d{1,6}(\.\d{1,6})?$/.test(value)) return NaN;
  const [whole, fraction = ''] = value.split('.');
  return Number(whole) * 1000000 + Number(fraction.padEnd(6, '0'));
}
export function latestSupplierQuotes(product: CatalogProduct): PurchaseQuote[] {
  const result = new Map<string, PurchaseQuote>();
  for (const q of product.quotes) {
    const key = q.supplier.normalize('NFKC').toLocaleLowerCase('fr').trim();
    const prev = result.get(key);
    if (!prev || q.date >= prev.date) result.set(key, q);
  }
  return [...result.values()].sort(
    (a, b) => a.unitTtcMicros - b.unitTtcMicros || a.supplier.localeCompare(b.supplier, 'fr'),
  );
}
export function ttcPrice(micros: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(micros / 1000000);
}
export function isCatalogProduct(v: unknown): v is CatalogProduct {
  if (!v || typeof v !== 'object') return false;
  const p = v as CatalogProduct;
  return (
    typeof p.id === 'string' &&
    typeof p.name === 'string' &&
    typeof p.unit === 'string' &&
    typeof p.active === 'boolean' &&
    Number.isSafeInteger(p.purchasePriceMinor) &&
    Array.isArray(p.quotes) &&
    p.quotes.length > 0 &&
    p.quotes.every(
      (q) =>
        typeof q.supplier === 'string' &&
        typeof q.reference === 'string' &&
        typeof q.date === 'string' &&
        Number.isSafeInteger(q.unitTtcMicros),
    )
  );
}
